import UserPageModalReview from './UserPageModalReview';

export default UserPageModalReview;
